import {
  get,
  post
} from './http'
import {
  getCustomUrl,
  postCustomUrl
} from './httpCustom'

const key = '0e7ccbddeb6394c8e116632b15ca87da';

export default {

  getBaiduIdCard(baseImg) {
    return postCustomUrl('User/IDCardReading', {
      image: baseImg,
    }, )
  },

  getorderDetail(openid,orderid) {
    return getCustomUrl('Event/getBookingMessage', {
      openid: openid,
      orderid:orderid,
    }, )
  },

  getFarePrediction(dataObj) {
    return post('AppointOrder/getFarePrediction', dataObj);
  },
  getFarePrediction2(oriAddr, oriLng, oriLat, desAddr, desLng, desLat, bookingDate) {
    return post('AppointOrder/getFarePrediction', {
      bookingDate: bookingDate,
      serviceType: 2,
      bookingStartAddr: oriAddr,
      bookingStartPointLo: oriLng,
      bookingStartPointLa: oriLat,
      bookingEndAddr: desAddr,
      bookingEndPointLo: desLng,
      bookingEndPointLa: desLat,
      city: '中山市'
    });
  },

  convertAddressToLocation(city, address) {
    return getCustomUrl('https://restapi.amap.com/v3/place/text', {
      city: city,
      keywords: address,
      output: 'json',
      key: key
    });
  },
  convertLocationToAddress(location) {
    return getCustomUrl('https://restapi.amap.com/v3/geocode/regeo', {
      location: location,
      key: key,
      output: 'json',
      radius: 1000,
      extensions: 'base',
      roadlevel: 0
    });
  },
  driverSearch(oriLocation, desLocation) {
    return getCustomUrl('https://restapi.amap.com/v3/direction/driving', {
      origin: oriLocation,
      destination: desLocation,
      output: 'json',
      key: key
    })
  },
  getAppointOrderList(StartDate, EndDate, OrderType = '', DateType = 'set', Token = '', Page = 1, Start = 0,
    Limit =
    100) {
    return get('Manager/AppointOrderManager/getAppointOrderListByManager', {
      startdate: StartDate,
      enddate: EndDate,
      datetype: DateType,
      ordertype: OrderType,
      page: Page,
      start: Start,
      limit: Limit,
      token: Token
    });
  },
  getAppointLimitDateList(LimitType) {
    return get('Manager/AppointOrderManager/getAppointLimitList', {
      type: LimitType
    });
  },
  invalidPickupLimit(OpenId, RecordID) {
    return post('Manager/AppointOrderManager/invalidPickupLimit', {
      openid: OpenId,
      id: RecordID
    });
  },
  addLimit(OpenId, Start, End, starttime = '', endtime = '', LimitType, IsGo = true) {
    return post('Manager/AppointOrderManager/addLimit', {
      openid: OpenId,
      startdate: Start,
      enddate: End,
      starttime: starttime,
      endtime: endtime,
      limittype: LimitType,
      isGo: IsGo
    });
  },
  getAppointStatReportList(OpenId, Start, End, DateType) {
    return get('Manager/AppointOrderManager/getAppointStatReportList', {
      openid: OpenId,
      startdate: Start,
      enddate: End,
      datetype: DateType
    });
  },
  getAppointOrderListByStat(Token, dateTime, IsShort = 1, IsGo = 1) {
    return get('Manager/AppointOrderManager/getAppointOrderListByStat', {
      token: Token,
      date: dateTime,
      isshort: IsShort,
      isgo: IsGo
    });
  },
  getDriverList(Token = '', ID = '') {
    return get('Driver/getDriverList', {
      token: Token,
      id: ID
    });
  },
  bindDriverToAppointOrder(OpenId, DriverName, OrderId, IsBind = 1, Token = '') {
    return post('Manager/AppointOrderManager/BindOrderToDriver/', {
      openid: OpenId,
      drivername: DriverName,
      id: OrderId,
      bind: IsBind,
      token: Token
    });
  },
  GetUserHistoryOrderByApp(UserID,OrderType,ordernum) {
    return get('Search/GetUserHistoryOrderByApp', {
      UserID:UserID,
      OpenId:'',
      OrderType:OrderType,
      ordernum:ordernum,
    });
  },
  getCity(location) {
    return getCustomUrl('https://restapi.amap.com/v3/geocode', {
      location: location,
      output: 'json',
      key: key,
      radius:100
    })
  },

  CheckAppointOrderbookingDate(bookingDate) {
    return post('AppointOrder/CheckAppointOrderbookingDate', {
      bookingDate:bookingDate,
    });
  },

  GetOrderLatitudeList(time) {
    return post('AppointOrderManager/GetOrderLatitudeList', {
      date:time,
    });
  },
  GetAppOrderDispatchList(time) {
    return post('AppointOrderManager/GetAppOrderDispatchList', {
      date:time,
    });
  },
  CreateOrderDispatch(ordernums,drivername,setdate) {
    return post('AppointOrderManager/CreateOrderDispatch', {
      ordernums:ordernums,
      drivername:drivername,
      setdate:setdate,
    });
  },


}



// WEBPACK FOOTER //
// ./src/request/appointApi.js